import { Icon, Text } from '@yes.technology/react-toolkit'
import { useEffect } from 'react'
import {
  ButtonsWrapper,
  Container,
  Divider,
  IconButton,
  MainButton,
  PositionCounter
} from './Media.styles'

export type MediaProps = {
  currentPosition: number
  realPosition?: string
  total: number
  lastPosition: number
  onNavigateNext: () => void
  onNavigate: (position: number) => void
  intervalTime?: number
  color?: string
  setIsPlaying: (state: boolean) => void
  isPlaying: boolean
}

const DEFAULT_INTERVAL_TIME = 30000

const addZeroToNumber = (number: number) =>
  Number.isInteger(number) ? ('0' + number).slice(-2) : number

const Media = ({
  currentPosition,
  realPosition,
  total,
  lastPosition,
  onNavigateNext,
  onNavigate,
  color,
  isPlaying,
  setIsPlaying,
  intervalTime = DEFAULT_INTERVAL_TIME
}: MediaProps) => {
  const togglePlayState = () => {
    if (!isPlaying && currentPosition === lastPosition) {
      onNavigate(0)
    }

    setIsPlaying(!isPlaying)
  }

  useEffect(() => {
    if (!isPlaying) return

    const interval = setInterval(() => {
      onNavigateNext()
    }, intervalTime)

    return () => {
      clearInterval(interval)
    }
  }, [isPlaying, onNavigateNext, intervalTime])

  const navigateToPrev = () => {
    onNavigate(currentPosition === 0 ? lastPosition : currentPosition - 1)
  }

  return (
    <Container>
      <ButtonsWrapper>
        <IconButton onClick={() => onNavigate(0)} color={color}>
          <Icon iconName='Previous' icColor='_006BFF' />
        </IconButton>
        <IconButton onClick={navigateToPrev} color={color}>
          <Icon iconName='PreviousSingleArrow' icColor='_006BFF' />
        </IconButton>
        <MainButton onClick={togglePlayState} color={color}>
          <Icon
            iconName={isPlaying ? 'Pause' : 'Play'}
            icSize='small'
            icColor='white'
          />
        </MainButton>
        <IconButton onClick={onNavigateNext} color={color}>
          <Icon iconName='FowardSingleArrow' icColor='_006BFF' />
        </IconButton>
        <IconButton onClick={() => onNavigate(lastPosition)} color={color}>
          <Icon iconName='Foward' icColor='_006BFF' />
        </IconButton>
      </ButtonsWrapper>
      <Divider />
      <PositionCounter color={color}>
        <Text variant='content-emphasis-07'>
          {addZeroToNumber(
            realPosition ? Number(realPosition) : currentPosition + 1
          )}
        </Text>
        <Text variant='content-07'>/{addZeroToNumber(total)}</Text>
      </PositionCounter>
    </Container>
  )
}

export default Media
